
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/zebra",
      function () {
        return require("private-next-pages/services/zebra/index.tsx");
      }
    ]);
  